import * as Config from '../../../../../config';
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import '../../../playlist/Playlist.css';
import './Twenty.css';

import ListColumns from '../../../content/list/ListColumns';
import CoverAction from '../../../common/CoverAction';
import FilterSelect from '../../../common/FilterSelect';
import Spinner from '../../../common/Spinner';
import TwentyLogo from '../svg/TwentyLogo';
import Card from '../../../common/Card';
import Button from '../../../common/Button';

import { setSelectedItems, openDrawer } from "../../../../../actions/index";

function ConnectedTwenty({
  style, api, dimension, isSubscribed, enableActionsButton, storePlaylists, storeAuth,
  setSelectedItems, openDrawer
}) {
  const { width } = dimension;
  const rows = 10;
  const columns = 2;
  const [current, setCurrent] = useState(null);
  const [charts, setCharts] = useState(null);

  // MAYBE - USE FOR LATER - PUBLISH DATE LIKE - /catalog/charts/?publish_date=2021-04-01:2021-04-07&name=The 20&per_page=1
  useEffect(() => {
    api.getFromApi(`/catalog/charts/?name=The 20&per_page=20`).then( response => {
      setCharts((response.data.results.length > 0) ? response.data.results : []);
      if (response.data.results.length > 0) {
        setCurrent(response.data.results[0])
      }
    })
  }, [api])

  const selectDate = (index) => { setCurrent(charts[index]) }
  const imgClick = (index) => () => { selectDate(index) }

  const beginDrag = () => {
    openDrawer();
    api.getFromApi(`/catalog/charts/${current.id}/tracks/?per_page=20`).then( response => {
      setSelectedItems([...response.data.results.map(Config.formattedFromBP)])
    } ).catch( e => console.log(`error`, e) );
  }

  const directCopy = () => {
    if (enableActionsButton) {
      api.getFromApi(`/catalog/charts/${current.id}/tracks/?per_page=20`).then( response => {

        const extra = {
          covers: (current.image) ? [current.image.uri] : null,
          fromDJ: current.name.toUpperCase(),
          fromDJID: null
        }
        const data = [...response.data.results.map(Config.formattedFromBP)];
        storePlaylists.new(current.name, data, extra);

        if (isSubscribed) { // LINK
          const dataEvent = data.map( x => ({ track_id: x.id, source_item_type: `Playlist`, source_item_id: current.id }) );
          storePlaylists.report(`/events/save-to-library/`, dataEvent);
        }

      } ).catch( e => console.log(`error`, e) );
    } else {
      storeAuth.welcome();
    }
  }

  return (
    <>
      <TwentyLogo />
      { current ? (
        <>
          <div className={`flexRow dnav20`}>
            { charts.map( (x,i) => (
              <div key={`DCC${i}`} className={`flexColumn`}>
               <CoverAction onClick={imgClick(i)} alt={`cover-the20-${i}`} className={(current.id === x.id) ? `selected` : ``} src={x.image.uri} size={Config.DNAV_COVER_SIZE} />
                <span className={`type-micro ${current.id === x.id ? `type-light` : `type-secondary` }`}>{x.name.replace(`The 20 - `, ``)}</span>
              </div>
            )) }
          </div>

          <div className={`flexRow card-container-playlist bsrc`}>
            <Card
              images={[(current.image) ? current.image.uri : Config.DEFAULT_IMG]}
              audio={{
                id: current.id,
                name: current.name,
                tracks: current.track_count,
                showDNav: false,
                extra: {
                  covers: (current.image) ? [current.image.uri] : null,
                  fromDJ: current.name.toUpperCase(),
                  fromDJID: null
                }
              }}
              dragEnabled={true}
              playEnabled={true}
              beginDrag={beginDrag}
              type={`TRACK-CARD`}
              style={{width: Config.PLAYLIST_COVER_SIZE }}
              ooWidth={Config.PLAYLIST_COVER_SIZE}
            />
            <div className={`playlist-infos`}>
              <p className={`playlist-title type-title`}>{current.name.toUpperCase()}</p>
              <p className={`playlist-p type-small`}>{Config.capAppName()}</p>
              <Button label={`Save playlist`} withLoading={true} className={`medium primary type-small playlist-button bsrc`} onClick={directCopy} style={{ marginTop: 20, width: 70}} />
            </div>
          </div>
          <FilterSelect values={ charts.map(x => x.name.replace(`The 20 - `, ``)) } width={140} height={250} selected={current.name.replace(`The 20 - `, ``)} onSelected={selectDate} className={`the20`}  />
          <ListColumns
            pathApi={`/catalog/charts/${current.id}/tracks`}
            id={`thetwenty`}
            width={width + (Config.LC_LEFT_PAD * columns)}
            height={(Config.LIST_ROW_HEIGHT * rows)}
            size={Config.LIST_ROW_HEIGHT}
            columnCount={columns}
            rowCount={rows}
            rowType={`Column`}
            hasPagination={false}
            style={{ marginTop: 16, paddingBottom: 26 }}
            enableArrows={true}
          />
        </>
      ) :  <Spinner className={`spinnerx-button`} /> }
    </>
  );
}

ConnectedTwenty.propTypes = {
  style: PropTypes.object
}

const Twenty = connect(
  state => ({
    api: state.api,
    dimension: state.dimension,
    isSubscribed: state.isSubscribed,
    enableActionsButton: (state.isSubscribed),
    storeAuth: state.storeAuth,
    storePlaylists: state.storePlaylists
  }),
  dispatch => ({
    setSelectedItems: items => dispatch(setSelectedItems(items)),
    openDrawer: () => dispatch(openDrawer()),
  })
)(ConnectedTwenty);

export default Twenty;
